<template>
  <div>
    <h3 class="title is-3">Billing</h3>

    <b-table
      :data="bills"
      :loading="isLoading"
      :default-sort="['rawStartDateTime', 'desc']"
      :striped="true"
      :hoverable="true">
      <template slot-scope="props">
        <b-table-column class="centered-table-content" field="gameName" label="Game name" sortable>
          {{ props.row.gameName }}
        </b-table-column>

        <b-table-column class="centered-table-content" field="rawStartDateTime" label="Dates" sortable>
          {{ props.row.formattedStartdateTime }}
        </b-table-column>

        <b-table-column class="centered-table-content" field="duration" label="Duration" sortable>
          <b-tooltip :label="props.row.tipDuration">
            <b-tag :type="isOverHours(props.row.duration)">
              {{ formatHours(props.row.duration) }}
            </b-tag>
          </b-tooltip>
        </b-table-column>

        <b-table-column class="centered-table-content" field="teamCount" label="Teams">
          {{ props.row.teamCount }}
          <b-icon pack="mdi"
            :icon="props.row.teamCount < 4 ? 'mars' : 'venus'">
          </b-icon>
        </b-table-column>

        <b-table-column class="centered-table-content" field="price" label="Fees (excl. GST)">
          <b-tooltip :label="props.row.tipFees">
            <b-tag :type="isOverFees(props.row.overFees)">
              ${{ props.row.price }}
            </b-tag>
          </b-tooltip>
        </b-table-column>

        <b-table-column class="centered-table-content" field="gameInvoiceStatus" label="Status">
          <b-tooltip :label="errorForPending" v-if="isPending(props.row.invoiceStatus)" :type="'is-danger'" animated>
            <b-tag :type="formatInvoiceStatus(props.row.invoiceStatus)">
              {{ props.row.invoiceStatus }}
            </b-tag>
          </b-tooltip>
          <b-tag :type="formatInvoiceStatus(props.row.invoiceStatus)" v-if="!isPending(props.row.invoiceStatus)">
            {{ props.row.invoiceStatus }}
          </b-tag>
        </b-table-column>
      </template>
    </b-table>

  </div>
</template>

<script>
  import billingService from '../services/billingService'
  import displayHelper from "../helpers/display-helper"

  export default {
    data () {
      return {
        isLoading: false,
        errorForPending: 'We are currently investigating for this invoice - please be patient',
        bills: [],
      }
    },
    created () {
      var parent = this
      this.isLoading = true
      billingService.getBilling()
        .then(bills => {
          this.bills = bills
          this.isLoading = false
        })
        .catch((err) => {
          displayHelper.displayError(parent, 'Oops, there was an error: ' + err.message)
        })
    },
    methods: {
      isOverHours (duration) {
        return duration < 240 ? '' : 'is-danger'
      },
      isOverFees (fee) {
        if (fee === 0) {
          return 'is-warning'
        } else if (fee === 1) {
          return 'is-success'
        } else if (fee === 2) {
          return 'is-danger'
        } else {
          return ''
        }
      },
      formatHours (minutes) {
        const h = Math.floor(minutes / 60)
        const m = minutes % 60
        return h + ':' + m
      },
      formatInvoiceStatus (status) {
        if (status === 'paid') {
          return 'is-success'
        } else if (status === 'invoiced') {
          return 'is-warning'
        } else if (status === 'overdue' || status === 'Pending') {
          return 'is-danger'
        } else if (status === 'free') {
          return 'is-info'
        } else {
          return ''
        }
      },
      isPending (status) {
        return status === 'Pending'
      }
    }
  }
</script>
